import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t } from 'i18next';

const MiraIframe = ({ url, onClose }) => {

    const navigate = useNavigate();
      const location = useLocation();
    
      const ssoData = useSelector((state) => state.sso.ssoUserData);
      const isHighmarkPortal = ssoData?.Portal === "Highmark";

        const { miraLoginURL } = location.state || {};
  debugger; 

  const handleBackClick = () => {
    navigate(-1); 
  };
  return (
     <>
    {isHighmarkPortal ? 
        <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">Mira</h2>
          </div>:
          <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">Mira</h2>
        </div>
    }
    <div>
      <iframe
        src={miraLoginURL}
        title="Content Viewer"
         style={{
      width: '100%', // Adjusted to fill the parent width
      height: '70vh', 
      border: 'none', 
      overflow: 'hidden' // Hides the scrollbar
    }}
    frameBorder="0"
      />
    </div>
    </>
  );
};

export default MiraIframe;
